import React, {Fragment, useEffect, useState} from 'react';
import {
    Alert,
    Breadcrumb,
    Button,
    Card,
    Col,
    Container,
    DatePicker,
    Form,
    Modal,
    RadioButton,
    Row,
    Table
} from "@deere/ux.uxframe-react";
import {Link, useHistory, useLocation} from 'react-router-dom';
import {
    ERROR_MESSAGE,
    ExpectedReceipts,
    FOUR,
    Inventory,
    Month,
    NEW_REQUEST2,
    ONE,
    ProjectedShipments,
    RemainingInventory,
    THREE,
    TWO
} from '../../shared/Constants';
import {Loading} from '../../shared/Loading';
import '../../index.css'
import {useAuthConfig} from "../../shared/utils";
import Moment from 'moment';
import {useOktaAuth} from "@okta/okta-react";
import {Box} from "@deere/fuel-react";

export default function NewRequest2() {
    const {authState} = useOktaAuth();
    let authAxios = useAuthConfig();
    const location = useLocation();
    const [alertVisible, setAlertVisible] = useState(false);
    const [weight, setWeight] = useState(0);
    const [availQtyNegative, setAvailQtyNeagative] = useState("");
    const [available_date, setDate] = useState("")
    const [reason, setReason] = useState("")
    const [urgency, setUrgency] = useState("")
    const [destination, setDestination] = useState("")
    const [replenshment_source, setReplenishment] = useState("");
    const [deliverattention, setDeliverAttention] = useState("")
    const [comments, setComments] = useState("");
    const [availQty, setAvailQty] = useState({});
    const [recquantity, setRecQuantity] = useState(0);
    const [time, setTime] = useState("");
    const [formError, setFormError] = useState("");
    const [message, setMessage] = useState("");
    const [dateWarning, setDateWarning] = useState(false);
    const [shipDateWarning, setShipDateWarning] = useState(false);
    const [modal, setModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [pdc, setPdc] = useState({});
    const [pdcLocation, setpdcLocation] = useState("");
    const history = useHistory();
    const [pdcPart, setPdcPart] = useState({});
    const [requestDetails, setRequestDetails] = useState([]);
    const [isDisabled, setIsDisabled] = useState(false);
    const [pcsOfInventory, setPcsOfInventory] = useState("");
    const [factoryDailyUsage, setFactoryDailyUsage] = useState("");
    const [nextShipmentDate, setNextShipmentDate] = useState("");
    const [whyNeededFrmPDC, setWhyNeededFrmPDC] = useState("")
    
    const makeMessageHidden = () => {
        const timeout = setTimeout(() => {
            setAlertVisible(false)
        }, 5000)
        return () => clearTimeout(timeout)
    }
    useEffect(() => {
        if (authState.accessToken !== null) {
            getRequestDetails();
            getSapdetails();
            getPdc();
        }
    }, [authState])
    const getPdc = async () => {
        setIsLoading(true);
        await authAxios.post(`/PDCReturn/PdcDetails`, {material: location.state.material}).then(
            response => {
                const resp = response.data;
                let qty1 = resp?.invQtyHand - location.state.quantity;
                let qty2 = qty1 + resp?.prjtdReceipts1 - resp?.b474MthPrjdShp1;
                let qty3 = qty2 + resp?.prjtdReceipts2 - resp?.b474MthPrjdShp2;
                let qty4 = qty3 + resp?.prjtdReceipts3 - resp?.b474MthPrjdShp3;
                let qty5 = qty4 + resp?.prjtdReceipts4 - resp?.b474MthPrjdShp4;
                setAvailQty({
                    ...availQty,
                    availQty1: qty1,
                    availQty2: qty2,
                    availQty3: qty3,
                    availQty4: qty4,
                    availQty5: qty5
                })
                setWeight(location.state.quantity * resp?.shipWgtPerPiece);
                if (resp.facilityIndicator === "0") {
                    setpdcLocation("PDC");
                } else if (resp.facilityIndicator === "1") {
                    setpdcLocation("ADC");
                } else {
                    setpdcLocation("UNKNOWN");
                }
                if (qty1 <= 0 || qty2 <= 0 || qty3 <= 0 || qty4 <= 0 || qty5 <= 0) {
                    setAvailQtyNeagative("YES");
                } else {
                    setAvailQtyNeagative("NO")
                }
                let lowQuantity = resp?.invQtyHand;
                if (qty1 < lowQuantity) {
                    lowQuantity = qty1;
                }
                if (qty2 < lowQuantity) {
                    lowQuantity = qty2;
                }
                if (qty3 < lowQuantity) {
                    lowQuantity = qty3;
                }
                if (qty4 < lowQuantity) {
                    lowQuantity = qty4;
                }
                if (qty5 < lowQuantity) {
                    lowQuantity = qty5;
                }
                let recquantity = 0
                if (lowQuantity === 0) {
                    recquantity = +location.state.quantity - 1;
                } else {
                    recquantity = +location.state.quantity + +lowQuantity - 1;
                }
                setRecQuantity(recquantity);
                if (qty1 < 0) {
                    setMessage(`You have requested PDC send you more pieces than they have on the shelf.  It is not realistic to request more than ${recquantity} pieces.`)
                    setAlertVisible(true);
                }
                setPdc(resp);
                setIsLoading(false);
            }
        ).catch(err => {
            setMessage(ERROR_MESSAGE);
            setAlertVisible(true)
            setIsLoading(false);
            makeMessageHidden()
        })
    }
    const getRequestDetails = async () => {
        setIsLoading(true);
        await authAxios.post(`/PDCReturn/Requestordetails`, {material: location.state.material}).then(
            response => {
                const resp = response.data;
                if (resp !== '') {
                    setRequestDetails(resp);
                }
                setIsLoading(false);
            }
        ).catch(err => {
            setMessage(ERROR_MESSAGE);
            setAlertVisible(true)
            setIsLoading(false);
            makeMessageHidden()
        })
    }
    const getSapdetails = async () => {
        setIsLoading(true);
        authAxios.post(`/PDCReturn/SupplierDetails`, {
            material: location.state.material,
            plant: location.state.plant
        }).then(
            response => {
                const resp = response.data
                if (resp !== '') {
                    setPdcPart(resp);
                }
                setIsLoading(false);
            }
        ).catch(err => {
            setMessage(ERROR_MESSAGE);
            setAlertVisible(true)
            setIsLoading(false);
            makeMessageHidden()
        })
    }
    useEffect(() => {
        if (location.state.plant === "NX01") {
            setTime("Next Business Day - (Magnum hot truck to factory will deliver by 6am)");
        } else if (location.state.plant === "EX01" || location.state.plant === "MX01" || location.state.plant === "MX32") {
            setTime("Next Business Day - 10:00am")
        } else if (location.state.plant === "HX01") {
            setTime("Next Business Day - 7:00am")
        } else if (location.state.plant === "T801") {
            setTime("Next Business Day - 9:30am")
        } else if (location.state.plant === "TX01") {
            setTime("Next Business Day - 6:00am")
        } else if (location.state.plant === "AX01") {
            setTime("Next Business Day - 6:00am (Factory Only)")
        } else if (location.state.plant === "JL01") {
            setTime("Next Business Day - Late afternoon arrival")
        } else if (location.state.plant === "LV01" || location.state.plant === "TC01" || location.state.plant === "TC04" || location.state.plant === "TC37") {
            setTime("Next Business Day - 8:30am")
        } else if (location.state.plant === "GX01" || location.state.plant === "GX03") {
            setTime("Next Business Day - 11:00am")
        } else {
            setTime("Next Business Day - 9:00am")
        }
    }, [location.state.plant])
    const hideAlert = () => {
        setAlertVisible(false)
    }
    const handleCancel = () => {
        setModal(false);
        setIsDisabled(false);
    }
    const handleOk = () => {
        history.push({
            pathname: '/step3', state: {
                plant: location.state.plant, material: location.state.material, quantity: location.state.quantity,
                availQtyNegative: availQtyNegative, available_date: available_date, reason: reason,
                urgency: urgency, destination: destination, replenshment_source: replenshment_source,
                deliverattention: deliverattention, pcsOfInventory: pcsOfInventory, factoryDailyUsage: factoryDailyUsage, 
                nextShipmentDate: nextShipmentDate, whyNeededFrmPDC: whyNeededFrmPDC, typicalReplenishment: pdc.rqmntSrcCd,
                comments: comments, recquantity: recquantity, partdescription: pdc.partTermName,
                quantityontheshelf: pdc.invQtyHand, materialweight: pdc.shipWgtPerPiece,
                inventoryclass: pdc.invtyClassCdSvp, location: pdcLocation,
                mrpController: pdcPart.mrpController, partPlanner: pdcPart.pdmName,
                sourceSuppName: pdcPart.splrNm, supplier: pdcPart.ordFrmSplrOrig
            }
        })
    }
    const handleDateChange = (event) => {
        setDate(event.target.value);
        setDateWarning(false)
    }

    const handleShipDateChange = (event) => {
        setNextShipmentDate(event.target.value);
        setShipDateWarning(false)
    }

    
    const handleReason = (event) => {
        setReason(event.target.value);
    }
    const handleUrgency = (event) => {
        setUrgency(event.target.value);
    }
    const handleDestination = (event) => {
        setDestination(event.target.value);
    }
    const validateForm = () => {
        let error = false;
        if (reason === '') {
            error = {
                reason_id: 'reason',
                message: '',
            };
            return error;
        }
        if (urgency === '') {
            error = {
                urgency_id: 'urgency',
                message: '',
            };
            return error;
        }
        if (destination === '') {
            error = {
                destination_id: 'destination',
                message: '',
            };
            return error;
        }
        if (deliverattention === '') {
            error = {
                deliverattention_id: 'deliverattention',
                message: '',
            };
            return error;
        }
        return error;
    };
    const handleSubmit = (e) => {
        setFormError(null);
        setIsDisabled(true);
        let error = validateForm();
        if (error) {
            setIsDisabled(false);
            setFormError(error);
            return;
        } else if (nextShipmentDate === '') {
            setShipDateWarning(true);
            setIsDisabled(false);
        } else if (availQtyNegative === "YES" && available_date === '') {
            setDateWarning(true);
            setIsDisabled(false);
        } else if (availQty.availQty1 < 0) {
            setModal(true);
        } else {
            history.push({
                pathname: '/step3', state: {
                    plant: location.state.plant, material: location.state.material, quantity: location.state.quantity,
                    availQtyNegative: availQtyNegative, available_date: available_date, reason: reason,
                    urgency: urgency, destination: destination, replenshment_source: replenshment_source,
                    deliverattention: deliverattention, pcsOfInventory: pcsOfInventory, factoryDailyUsage: factoryDailyUsage, 
                    nextShipmentDate: nextShipmentDate, whyNeededFrmPDC: whyNeededFrmPDC, typicalReplenishment: pdc.rqmntSrcCd,
                    comments: comments, recquantity: recquantity, partdescription: pdc.partTermName,
                    quantityontheshelf: pdc.invQtyHand, materialweight: pdc.shipWgtPerPiece,
                    inventoryclass: pdc.invtyClassCdSvp, location: pdcLocation,
                    mrpController: pdcPart.mrpController, partPlanner: pdcPart.pdmName,
                    sourceSuppName: pdcPart.splrNm, supplier: pdcPart.ordFrmSplrOrig
                }
            })
        }
        e.preventDefault();
    }
    const handleRecentRequestLinkClick = (e, params) => {
        window.open(`/requestDetails/${location.state.material}/${params[0]}/${params[2]}/step2/${location.state.quantity}`, "_self")
    }
    return (
        <Fragment>
            <title>PDC Parts Request Form (step 2)</title>
            {alertVisible ?
                <Alert id="snackbar" onClose={hideAlert} accessibilityLabel="Success:" variant="warning"
                       aria-atomic="true">
                <span className="uxf-alert-description">
                    {message}
                </span>
                </Alert> : null}
            {isLoading ? (
                <Loading/>
            ) : null}
            {modal ? <Modal.Dialog id="snackbar1" animation={true} autoFocus={true} show={modal}>
                <Modal.Body>
                    <Alert variant="warning" role="alertdialog">
                        <span className="uxf-alert-title">
                            You are trying to recall more pieces than PDC had on Saturday.
                            Unless they received another shipment since Saturday they cannot send you this many.
                            Consider revising your request to {recquantity} pieces.
                            Press OK to continue or cancel to go back."
                        </span>
                    </Alert>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="info" onClick={handleOk}>Ok</Button>
                    <Button variant="secondary" onClick={handleCancel}>Cancel</Button>
                </Modal.Footer>
            </Modal.Dialog> : null}
            {location.state.message ?
                <Box margin="1.5rem">
                    <Alert
                        variant="warning"
                        title="MRBR/EDI810 Report - Issues" aria-atomic="true">
                <span className="uxf-alert-description">
                            {location.state.message}
                    </span>
                    </Alert>
                </Box>
                : null}
            <Card style={{margin: '2%'}}>
                <Card.Body>
                    <Container fluid="xl">
                        <Row>
                            <Col xs={24}>
                                <Form.Group as={Row} className="mb-3">
                                    <Breadcrumb links={[{
                                        title: "Home",
                                        to: "/"
                                    }, {
                                        title: "Step1",
                                        to: "/step1"
                                    },
                                        {
                                            title: "Step2"
                                        }]} label="breadcrumbs"
                                                breadcrumbItemProps={{linkAs: Link}}/>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24}>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className='firstline' style={{marginLeft: '1.5%'}}>
                                        {NEW_REQUEST2}
                                    </Form.Label>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Container>
                    <Form>
                        <Container>
                            <Card style={{marginLeft: '5%', marginRight: '5%'}}>
                                <Card.Body>
                                    <Card.Title>Request</Card.Title>
                                    <Row>
                                        <Col xs={12} md={7}>
                                            <Form.Group style={{marginLeft: '1%'}}>
                                                <Form.Label>Plant:</Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{marginLeft: '1%'}}>
                                                <Form.Label>Material:</Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{marginLeft: '1%'}}>
                                                <Form.Label>Quantity:</Form.Label>
                                            </Form.Group>
                                            {requestDetails.length > 0 ?
                                                <Form.Group style={{marginLeft: '1%'}}>
                                                    <Form.Label>Recent Requests:</Form.Label>
                                                </Form.Group>
                                                : null}
                                        </Col>
                                        <Col xs={12} md={10}>
                                            <Form.Group>
                                                <Form.Label>{location.state.plant}</Form.Label>
                                            </Form.Group>
                                            <Form.Group>
                                                <Form.Label>{location.state.material}</Form.Label>
                                            </Form.Group>
                                            <Form.Group>
                                                <Form.Label>{location.state.quantity}</Form.Label>
                                            </Form.Group>
                                            {requestDetails.length > 0 ?
                                                <Form.Group>
                                                    <Form.Label>{requestDetails.map(index => (
                                                        <Button style={{padding: 0, paddingBottom: 3}} variant="link"
                                                                onClick={(e) => handleRecentRequestLinkClick(e, index)}>{index[1]} at {Moment(index[2]).format('H:MM:SS A')} on {Moment(index[2]).format('DD MMM YYYY')}</Button>))}</Form.Label>
                                                </Form.Group> : null}
                                        </Col>
                                    </Row>
                                    <br/>
                                </Card.Body>
                            </Card>
                            <br/> 
                            <Card style={{marginLeft: '5%', marginRight: '5%'}}>
                                <Card.Body>
                                    <Card.Title>PDC Information</Card.Title><br/>
                                    <Form.Label style={{"color": "#0000ff"}}>Note: This PDC data is updated on Saturdays
                                        only.</Form.Label><br/><br/>
                                        <Row>
                                        <Col xs={12} md={7}>
                                            <Form.Group style={{marginLeft: '1%'}}>
                                                <Form.Label>Part description:</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md={30}>
                                            <Form.Group>
                                                <Form.Label>{pdc.partTermName}&nbsp;</Form.Label>
                                            </Form.Group>
                                        </Col>
										</Row>
                                    <Row>
                                        <Col xs={12} md={7}>
                                            <Form.Group style={{marginLeft: '1%'}}>
                                                <Form.Label>Quantity on the shelf (PRIM3):</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md={30}>
										                                            <Form.Group>
                                                <Form.Label>{pdc.invQtyHand}&nbsp;</Form.Label>
                                            </Form.Group>
                                        </Col>
										</Row>
                                    <Row>
                                        <Col xs={12} md={7}>
                                            <Form.Group style={{marginLeft: '1%'}}>
                                                <Form.Label>Weight:</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md={30}>
                                            <Form.Group>
                                                <Form.Label>{pdc.shipWgtPerPiece} pounds each ({weight} pounds
                                                    total)&nbsp;</Form.Label>
                                                {weight > 150 ? <> 
                                                    <Form.Label style={{color: "red",fontWeight: "bold"}}>Parts are greater than 150 lbs total, PFR or LTL will be used. Cannot go UPS.</Form.Label>
                                                </> : null }
                                            </Form.Group>

                                        </Col>
									</Row>
                                    <Row>
                                        <Col xs={12} md={7}>
                                            <Form.Group style={{marginLeft: '1%'}}>
                                                <Form.Label>Inventory Class:</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md={30}>
                                            <Form.Group>
                                                <Form.Label>{pdc.invtyClassCdSvp}&nbsp;</Form.Label>
                                            </Form.Group>
                                        </Col>
										</Row>
                                    <Row>
                                        <Col xs={12} md={7}>
                                            <Form.Group style={{marginLeft: '1%'}}>
                                                <Form.Label>Replenishment Factory:</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md={30}>
                                            <Form.Group>
                                                <Form.Label>{pdc.partActngUnit}&nbsp;{pdc.partActngUnit === "H00" ?
                                                    <b>Harvester materials require manual management
                                                        approval</b> : null}</Form.Label>
                                            </Form.Group>
                                        </Col>
									</Row>
                                    <Row>
                                        <Col xs={12} md={7}>
                                            <Form.Group style={{marginLeft: '1%'}}>
                                                <Form.Label>Location:</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md={30}>
                                            <Form.Group>
                                                <Form.Label>{pdcLocation}&nbsp;</Form.Label>
                                            </Form.Group>
                                        </Col>
									</Row>
                                    <Row>
                                        <Col xs={12} md={7}>
                                            <Form.Group style={{marginLeft: '1%'}}>
                                                <Form.Label>Accounting Unit:</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md={30}>
                                            <Form.Group>
                                                <Form.Label>{pdc.dnsRplSrceCurr}&nbsp;</Form.Label>
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                </Card.Body>
                            </Card>
                            <br/>
                            <Card style={{marginLeft: '5%', marginRight: '5%'}}>
                                <Card.Body>
                                    <Card.Title>Factory Inventory Scenario</Card.Title>

                                    <Row>
                                        <Col xs={12} md={12}>
                                            <Form.Group style={{marginLeft: '1%'}}>
                                                <Form.Label>Pcs of Inventory at my factory:</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md={12}>
                                            <Form.Group>
                                            <Form.Control type="number" maxLength="6" id="pcsOfInventory" name="pcsOfInventory" required
                                                value={pcsOfInventory} //onKeyPress={handleKeyPress} 
                                                onChange={(e) => setPcsOfInventory(e.target.value)} 
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} md={12}>
                                            <Form.Group style={{marginLeft: '1%'}}>
                                                <Form.Label>Factory daily usage:</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md={12}>
                                            <Form.Group>
                                            <Form.Control type="number" maxLength="6" id="factoryDailyUsage" name="factoryDailyUsage" required
                                                value={factoryDailyUsage} //onKeyPress={handleKeyPress} 
                                                onChange={(e) => setFactoryDailyUsage(e.target.value)} 
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} md={12}>
                                            <Form.Group style={{marginLeft: '1%'}}>
                                                <Form.Label>Suppliers next shipment to factory will arrive (xx/mm/yyyy):</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md={12}>
                                            <Form.Group>
                                            <DatePicker name="nextShipmentDate" onInput={handleShipDateChange}
                                                                selected={nextShipmentDate} hideLabel={true}
                                                                required id="nextShipmentDate"
                                                                inputAriaLabel="date format: dd-mmm-yyyy"/>
                                                                                                                <Form.Label>{shipDateWarning ?
                                                    <span style={{"color": "red"}}>Please fill in the next shipment date.</span> : null}</Form.Label>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} md={12}>
                                            <Form.Group style={{marginLeft: '1%'}}>
                                                <Form.Label>Requestor comments on factory inventory situation – why is this order needed from PDC? :</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md={12}>
                                            <Form.Group>
                                            <Form.Control type="text" maxLength="50" id="whyNeededFrmPDC"
                                                              name="whyNeededFrmPDC" value={whyNeededFrmPDC}
                                                              onChange={(e) => setWhyNeededFrmPDC(e.target.value)} required />
                                                <Form.Label>{formError && formError.deliverattention_id === 'whyNeededFrmPDC' ?
                                                    <Form.Label
                                                        style={{color: "red"}}>&nbsp;</Form.Label> : null}</Form.Label>
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                </Card.Body>
                            </Card>
                            <br/>
                            <Card style={{marginLeft: '5%', marginRight: '5%'}}>
                                <Card.Body>
                                    <Card.Text>
                                        <Table borderless size="sm" responsive>
                                            <thead>
                                            <tr>
                                                <th scope="col" className="text-center">{Month}</th>
                                                <th scope="col" className="text-center">{RemainingInventory}</th>
                                                <th scope="col" className="text-center">{ExpectedReceipts}</th>
                                                <th scope="col" className="text-center">{ProjectedShipments}</th>
                                                <th scope="col" className="text-center">{Inventory}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td className="text-center">{ONE}</td>
                                                {availQty.availQty1 <= 0 ? <td className="text-center"><font
                                                        color="#f0000">{availQty.availQty1}</font></td>
                                                    : <td className="text-center">{availQty.availQty1}</td>}
                                                <td className="text-center">{pdc.prjtdReceipts1}</td>
                                                <td className="text-center">{pdc.b474MthPrjdShp1}</td>
                                                {availQty.availQty2 <= 0 ? <td className="text-center"><font
                                                        color="#f0000">{availQty.availQty2}</font></td>
                                                    : <td className="text-center">{availQty.availQty2}</td>}
                                            </tr>
                                            <tr>
                                                <td className="text-center">{TWO}</td>
                                                {availQty.availQty2 <= 0 ? <td className="text-center"><font
                                                        color="#f0000">{availQty.availQty2}</font></td>
                                                    : <td className="text-center">{availQty.availQty2}</td>}
                                                <td className="text-center">{pdc.prjtdReceipts2}</td>
                                                <td className="text-center">{pdc.b474MthPrjdShp2}</td>
                                                {availQty.availQty3 <= 0 ? <td className="text-center"><font
                                                        color="#f0000">{availQty.availQty3}</font></td>
                                                    : <td className="text-center">{availQty.availQty3}</td>}
                                            </tr>
                                            <tr>
                                                <td className="text-center">{THREE}</td>
                                                {availQty.availQty3 <= 0 ? <td className="text-center"><font
                                                        color="#f0000">{availQty.availQty3}</font></td>
                                                    : <td className="text-center">{availQty.availQty3}</td>}
                                                <td className="text-center">{pdc.prjtdReceipts3}</td>
                                                <td className="text-center">{pdc.b474MthPrjdShp3}</td>
                                                {availQty.availQty4 <= 0 ? <td className="text-center"><font
                                                        color="#f0000">{availQty.availQty4}</font></td>
                                                    : <td className="text-center">{availQty.availQty4}</td>}
                                            </tr>
                                            <tr>
                                                <td className="text-center">{FOUR}</td>
                                                {availQty.availQty4 <= 0 ? <td className="text-center"><font
                                                        color="#f0000">{availQty.availQty4}</font></td>
                                                    : <td className="text-center">{availQty.availQty4}</td>}
                                                <td className="text-center">{pdc.prjtdReceipts4}</td>
                                                <td className="text-center">{pdc.b474MthPrjdShp4}</td>
                                                {availQty.availQty5 <= 0 ? <td className="text-center"><font
                                                        color="#f0000">{availQty.availQty5}</font></td>
                                                    : <td className="text-center">{availQty.availQty5}</td>}
                                            </tr>
                                            </tbody>
                                        </Table>
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                            <br/>
                            {availQtyNegative === "YES" ? <>
                                <Card style={{marginLeft: '5%', marginRight: '5%'}}>
                                    <Card.Body>
                                        <Card.Text>
                                            <Form.Group style={{color: "red", marginLeft: '0.5%'}}>
                                                <Form.Label><font style={{fontWeight: "bold"}}>The values in the
                                                    "Inventory" or "Remaining Inventory" are
                                                    negative.</font></Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{marginLeft: '1%'}}>
                                                <Form.Label><font style={{fontWeight: "bold"}}>Please answer the
                                                    following questions...</font></Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{marginLeft: '1%'}}>
                                                <Form.Label>- Why are the parts not available?</Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{marginLeft: '1%'}}>
                                                <Form.Label>- When will the parts being pulled from PDC be
                                                    replaced?</Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{marginLeft: '1%'}}>
                                                <Form.Label>- What is the consequence of not getting the parts from
                                                    PDC?</Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{marginLeft: '1%'}}>
                                                <Form.Control as="textarea" cols="94" rows="4" maxLength="750"
                                                              name="comments" id="comments"
                                                              onChange={(e) => setComments(e.target.value)} required/>
                                                <Form.Label>{formError && formError.comments_id === 'comments' ?
                                                    <Form.Label
                                                        style={{color: "red"}}>{formError.message}</Form.Label> : null}</Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{marginLeft: '1%'}}>
                                                <Form.Label><b>A replenishment plan is required. </b> The typical
                                                    replenishment source is {pdc.rqmntSrcCd}.</Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{marginLeft: '1%'}}>
                                                <Form.Label>These parts will be replenished at PDC by:</Form.Label><br/>
                                                <RadioButton style={{marginLeft: '2%'}} id="replenshment1"
                                                             label="Vendor Direct (supplier shipping direct to PDC)"
                                                             value="V" name="replenishment_source" required
                                                             onChange={(e) => setReplenishment(e.target.value)}/>
                                                <RadioButton style={{marginLeft: '2%'}} id="replenshment2"
                                                             label="Factory fill (from plant inventory once available)"
                                                             value="R" name="replenishment_source" required
                                                             onChange={(e) => setReplenishment(e.target.value)}/>
                                                <Form.Label>{formError && formError.replenishment_source_id === 'replenshment_source' ?
                                                    <Form.Label
                                                        style={{color: "red"}}>{formError.message}</Form.Label> : null}</Form.Label>
                                            </Form.Group>
                                            <Form.Group as={Row} style={{marginLeft: '1%'}}>
                                                <Form.Label>Earliest date the parts will be available to pick from
                                                    factory/ship from the supplier is:</Form.Label>
                                                <Col xs={12} md={5}>
                                                    <DatePicker name="available_date" onInput={handleDateChange}
                                                                selected={available_date} hideLabel={true}
                                                                id="available_date"
                                                                inputAriaLabel="date format: dd-mmm-yyyy"/>
                                                </Col>
                                                <Form.Label>{dateWarning ?
                                                    <span style={{"color": "red"}}>Provide the earliest date the parts will be available to pick from factory/ship from the supplier.</span> : null}</Form.Label>
                                            </Form.Group>
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                                <br/> </> : null}
                            <Card style={{marginLeft: '5%', marginRight: '5%'}}>
                                <Card.Body>
                                    <Card.Title>Reason</Card.Title>
                                    <Card.Text>
                                        <Row style={{marginLeft: '1%'}}>
                                            <Col>
                                                <Form.Label>Supports Production:</Form.Label>
                                                <RadioButton id="reason1" label="Supplier Delinquent"
                                                             value="Supplier Delinquent" name="reason" required
                                                             onChange={handleReason}/>
                                                <RadioButton id="reason2" label="Supplier Quality Issue"
                                                             value="Supplier Quality Issue" name="reason" required
                                                             onChange={handleReason}/>
                                                <RadioButton id="reason3" label="New Product Program"
                                                             value="New Product Program" name="reason" required
                                                             onChange={handleReason}/>
                                                <RadioButton id="reason4" label="Transportation Delay-Carrier"
                                                             value="Transportation Delay Carrier" name="reason" required
                                                             onChange={handleReason}/>
                                                <RadioButton id="reason5" label="Transportation Delay-Supplier"
                                                             value="Transportation Delay Supplier" name="reason"
                                                             required onChange={handleReason}/>
                                                <RadioButton id="reason6" label="Specification Error"
                                                             value="Specification Error" name="reason" required
                                                             onChange={handleReason}/>
                                                <RadioButton id="reason7" label="Write Off" value="Write Off"
                                                             name="reason" required onChange={handleReason}/>
                                                <RadioButton id="reason8" label="Build Ahead" value="Build Ahead"
                                                             name="reason" required onChange={handleReason}/>
                                                <RadioButton id="reason9" label="Decision Change"
                                                             value="Decision Change" name="reason" required
                                                             onChange={handleReason}/>
                                                <RadioButton id="reason10" label="Container/Dunnage Shortage"
                                                             value="Container Dunnage Shortage" name="reason" required
                                                             onChange={handleReason}/>
                                                <RadioButton id="reason11" label="Sourcing Change"
                                                             value="Sourcing Change" name="reason" required
                                                             onChange={handleReason}/>
                                                <RadioButton id="reason12" label="Short Lead" value="Short Lead"
                                                             name="reason" required onChange={handleReason}/>
                                                <RadioButton id="reason13" label="Machines Down" value="Machines Down"
                                                             name="reason" required onChange={handleReason}/>
                                            </Col>
                                            <Col>
                                                <Form.Label>Does Not Support Production:</Form.Label>
                                                <RadioButton id="reason14" label="Marketing/Training Need"
                                                             value="Marketing/Training" name="reason" required
                                                             onChange={handleReason}/>
                                                <RadioButton id="reason15" label="Engineering/Test Need"
                                                             value="Engineering/Test" name="reason" required
                                                             onChange={handleReason}/>
                                                <RadioButton id="reason16" label="Kit Need (LSK)" value="Kit Need"
                                                             name="reason" required onChange={handleReason}/>
                                                <RadioButton id="reason17" label="PDC Surplus Return"
                                                             value="PDC Surplus Return" name="reason" required
                                                             onChange={handleReason}/>
                                                <RadioButton id="reason18" label="PDC Returning Rejected Material."
                                                             value="PDC Returning Rej" name="reason" required
                                                             onChange={handleReason}/>
                                                <RadioButton id="reason19"
                                                             label="Non-Current Manufacturing Need (high supplier MOQ; low volume requirements)"
                                                             value="Non-Current Manufacture" name="reason" required
                                                             onChange={handleReason}/>
                                            </Col>
                                            <Form.Label>{formError && formError.reason_id === 'reason' ? <Form.Label
                                                style={{color: "red"}}>{formError.message}</Form.Label> : null}</Form.Label>
                                        </Row>
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                            <br/>
                            <Card style={{marginLeft: '5%', marginRight: '5%'}}>
                                <Card.Body>
                                    <Card.Title>How soon is this really needed?</Card.Title>
                                    <Card.Text style={{marginLeft: '1%'}}>
                                        {(location.state.plant !== "NX01") ?
                                        <RadioButton label="Immediately" id="urgency" value="Immediately" name="urgency"
                                                     required onChange={handleUrgency}/>
                                        : null}
                                        {(location.state.plant === "NX01") ?
                                        <RadioButton label="Immediately (PFR for same day/off shift or shipping to external supplier)" id="urgency" value="Immediately" name="urgency"
                                                     required onChange={handleUrgency}/>
                                        : null}
                                        {(location.state.plant !== "H101" && location.state.plant !== "DW01") ?
                                            <RadioButton id="urgency1" label={time}
                                                         value="Next Business Day (first thing)" name="urgency" required
                                                         onChange={handleUrgency}/>
                                            : null}
                                        {(location.state.plant !== "AX01" && location.state.plant !== "AX02" && location.state.plant !== "H101" && location.state.plant !== "DW01" && location.state.plant !== "TX01") ?
                                            <RadioButton id="urgency2" label="2 Weeks" value="2 Weeks" name="urgency"
                                                         required onChange={handleUrgency}/>
                                            : null}
                                        <Form.Label>{formError && formError.urgency_id === 'urgency' ? <Form.Label
                                            style={{color: "red"}}>{formError.message}</Form.Label> : null}</Form.Label>
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                            <br/>
                            <Card style={{marginLeft: '5%', marginRight: '5%'}}>
                                <Card.Body>
                                    <Card.Title>Deliver To:</Card.Title>
                                    <Card.Text style={{marginLeft: '1%'}}>
                                        {location.state.plant === "AX01" ? <>
                                                <RadioButton name="destination" id="deliverto1"
                                                             label={`${location.state.plant} Factory`} value="Factory"
                                                             onChange={handleDestination} required/>
                                                <RadioButton name="destination" id="deliverto2" label="East Moline Warehouse"
                                                             value="EastMoline" onChange={handleDestination} required/></>
                                            : null}
                                        {location.state.plant === "AX02" ? <>
                                                <RadioButton name="destination" id="deliverto3" label="Factory"
                                                             value="Factory" onChange={handleDestination} required/>
                                                <RadioButton name="destination" id="deliverto4"
                                                             label="Magnum Warehouse (Should not be used for Urgent returns)"
                                                             required value="Magnum" onChange={handleDestination}/></>
                                            : null}
                                        {location.state.plant === "RX01" ? <>
                                                <RadioButton name="destination" id="deliverto5"
                                                             label="Ryder Logistics Center" value="Ryder"
                                                             onChange={handleDestination} required/>
                                                <RadioButton name="destination" id="deliverto6"
                                                             label="Drive Train Operations (DTO)" value="DTO"
                                                             onChange={handleDestination} required/></>
                                            : null}
                                        {location.state.plant === "HX01" ?
                                            <RadioButton name="destination" id="deliverto7"
                                                         label={`${location.state.plant} Factory`} value="Factory"
                                                         onChange={handleDestination} required/>
                                            : null}
                                        {location.state.plant === "NX01" ? <>
                                                <RadioButton name="destination" id="deliverto8" label="Factory (602SW State St)"
                                                             value="Factory" onChange={handleDestination} required/></>
                                            : null}
                                        {location.state.plant === "EX01" ?
                                            <RadioButton name="destination" id="deliverto10"
                                                         label={`${location.state.plant} Factory`} value="Factory"
                                                         onChange={handleDestination} required/>
                                            : null}
                                        {location.state.plant === "H101" ? <>
                                                <RadioButton name="destination" id="deliverto11"
                                                             label={`${location.state.plant} Factory`} value="Factory"
                                                             onChange={handleDestination} required/>
                                                <RadioButton name="destination" id="deliverto12"
                                                             label={`${location.state.plant} Z11/RIAM Warehouse`}
                                                             value="Z11/RIAM Warehouse" onChange={handleDestination}
                                                             required/></>
                                            : null}
                                        {location.state.plant === "JL01" ?
                                            <RadioButton name="destination" id="deliverto13"
                                                         label={`${location.state.plant} Factory`} value="Factory"
                                                         onChange={handleDestination} required/>
                                            : null}
                                        {location.state.plant === "T801" ? <>
                                                <RadioButton name="destination" id="deliverto15"
                                                             label={`${location.state.plant} plant3`} value="plant3"
                                                             onChange={handleDestination} required/>
                                            </>
                                            : null}
                                        {location.state.plant === "MX01" ? <>
                                                <RadioButton name="destination" id="deliverto16"
                                                             label={`${location.state.plant} Downtown (300 N Vine)`}
                                                             value="Factory" onChange={handleDestination} required/>
                                                <RadioButton name="destination" id="deliverto17"
                                                             label={`${location.state.plant} Gator Works (1501 W Lake)`}
                                                             value="GatorWorks" onChange={handleDestination} required/></>
                                            : null}
                                        {location.state.plant === "MX32" ?
                                            <RadioButton name="destination" id="deliverto18"
                                                         label={`${location.state.plant} Gator Works (1501 W Lake)`}
                                                         value="GatorWorks" onChange={handleDestination} required/>
                                            : null}
                                        {location.state.plant === "LV01" ?
                                            <RadioButton name="destination" id="deliverto19"
                                                         label={`${location.state.plant} Ryder`} value="Ryder"
                                                         onChange={handleDestination} required/>
                                            : null}
                                        {(location.state.plant === "GX01" || location.state.plant === "GX03") ? <>
                                            <RadioButton name="destination" id="deliverto20"
                                                         label={`${location.state.plant} Building A & C`}
                                                         value="BuildingAC" onChange={handleDestination} required/>
                                            <RadioButton name="destination" id="deliverto21"
                                                         label={`${location.state.plant} Building D`} value="BuildingD"
                                                         onChange={handleDestination} required/>
                                            <RadioButton name="destination" id="deliverto22"
                                                         label={`${location.state.plant} Building G`} value="BuildingG"
                                                         onChange={handleDestination} required/>
                                            <RadioButton name="destination" id="deliverto23"
                                                         label={`${location.state.plant} Building H`} value="BuildingH"
                                                         onChange={handleDestination} required/>
                                        </> : null}
                                        {(location.state.plant === "TC01" || location.state.plant === "TC04" || location.state.plant === "TC37") ?
                                            <RadioButton name="destination" id="delivert24"
                                                         label={`${location.state.plant} Factory`} value="Factory"
                                                         onChange={handleDestination} required/>
                                            : null}
                                        {location.state.plant === "DW01" ? <>
                                                <RadioButton name="destination" id="deliverto25"
                                                             label={`${location.state.plant} Factory`} value="Factory"
                                                             onChange={handleDestination} required/>
                                                <RadioButton name="destination" id="deliverto26" label="TM" value="TM"
                                                             onChange={handleDestination} required/>
                                            </>
                                            : null}
                                        {location.state.plant === "TX01" ? <>
                                                <RadioButton name="destination" id="deliverto27"
                                                             label={`${location.state.plant} Factory John Deere Cross Dock`}
                                                             value="Factory" onChange={handleDestination} required/>
                                                <RadioButton name="destination" id="deliverto28"
                                                             label={`${location.state.plant} W6`} value="W6"
                                                             onChange={handleDestination} required/>
                                            </>
                                            : null}
                                        {location.state.plant === "YK01" ?
                                            <RadioButton name="destination" id="deliverto30"
                                                         label={`${location.state.plant} Precision Upgrades`}
                                                         value="PU" onChange={handleDestination} required/>
                                            : null}
                                        <RadioButton name="destination" id="deliverto29"
                                                     label="Other External Destination (Not John Deere facilities... please see next page)"
                                                     value="other" onChange={handleDestination} required/>
                                        <Form.Label>{formError && formError.destination_id === 'destination' ?
                                            <Form.Label
                                                style={{color: "red"}}>{formError.message}</Form.Label> : null}</Form.Label>
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                            <br/>
                            <Card style={{marginLeft: '5%', marginRight: '5%'}}>
                                <Card.Body>
                                    <Card.Title>Deliver Attention:</Card.Title>
                                    <Row>
                                        <Col xs={12} md={7}>
                                            <Form.Group>
                                                <Form.Control type="text" maxLength="50" id="deliverattention"
                                                              name="deliverattention" required value={deliverattention}
                                                              onChange={(e) => setDeliverAttention(e.target.value)}/>
                                                <Form.Label>{formError && formError.deliverattention_id === 'deliverattention' ?
                                                    <Form.Label
                                                        style={{color: "red"}}>{formError.message}</Form.Label> : null}</Form.Label>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                            <br/>
                            <Row>
                                <Col xs={3} style={{marginLeft: '7%', marginRight: '5%'}}>
                                    <Form.Group style={{marginLeft: '5%', marginRight: '5%'}}>
                                        <Button variant="primary" type="submit" disabled={isDisabled}
                                                onClick={handleSubmit}>
                                            <font style={{"fontWeight": "bold"}}>Continue</font>
                                        </Button>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Container>
                    </Form>
                </Card.Body>
            </Card>
        </Fragment>
    )
}